import axios from "axios";
import { _logout } from "../Helper/helper";
import { SignJWT, jwtVerify } from "jose";

export default async function APIService(is_post, url, data = {}, is_auth) {

    const API_URL = process.env.REACT_APP_API_URL + url;
    const authToken = is_auth || sessionStorage.getItem("mintit_access_token");
    const jwt_secret_key = new TextEncoder().encode(process.env.REACT_APP_JWT_SECRET_KEY);

    // ---------------- Ensure request data is object ----------------
    let converted_params = data;

    if (typeof converted_params === "string") {
        try { converted_params = JSON.parse(converted_params); } catch {}
    }

    // Replace null values if needed
    if (typeof converted_params === "object" && converted_params !== null) {
        Object.keys(converted_params).forEach(key => {
            if (converted_params[key] === null) {
                converted_params[key] = "&?";
            }
        });
    }

    // ---------------- POST ----------------
    if (is_post === true) {
        const token = await new SignJWT({ ...converted_params })
            .setProtectedHeader({ alg: "HS256" })
            .sign(jwt_secret_key);

        return axios
            .post(API_URL, token, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${authToken}`,
                },
            })
            .then(async (response) => await decodeJWT(response.data))
            .catch(async (error) => await handleError(error));
    }

    // ---------------- GET ----------------
    return axios
        .get(API_URL, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${authToken}`,
            },
        })
        .then(async (response) => await decodeJWT(response.data))
        .catch(async (error) => await handleError(error));



    // -------------------------------------------------
    // ALWAYS decode JWT string (success or error)
    // -------------------------------------------------
    async function decodeJWT(jwt_string) {

        // Remove quotes if wrapped
        if (typeof jwt_string === "string" && jwt_string.startsWith('"') && jwt_string.endsWith('"')) {
            jwt_string = jwt_string.slice(1, -1);
        }

        try {
            const decoded = await jwtVerify(jwt_string, jwt_secret_key, {
                algorithms: ["HS256"],
            });

            const payload = decoded?.payload || {};

            // -------- Logout if unauthorized --------
            if (payload?.status_code === 401) {
                _logout();
            }

            return payload; // ALWAYS return decoded payload

        } catch (e) {
            return { status_code: 500, status: false, message: "Invalid server response" };
        }
    }



    // -------------------------------------------------
    // Handle Axios errors (HTTP errors)
    // -------------------------------------------------
    async function handleError(error) {

        // -------- Server returned an HTTP error (400/401/500 etc.) --------
        if (error?.response) {
            let errData = error.response.data;

            // Try to decode if server sent JWT error
            if (typeof errData === "string") {
                return await decodeJWT(errData);
            }

            // Normal JSON error with 401
            if (errData?.status_code === 401 || error.response.status === 401) {
                _logout();
            }

            return errData; // return original error object
        }

        // -------- No response (network issue) --------
        return { status_code: 500, status: false, message: "Network error" };
    }
}
